import { useState } from "react";

import { useResizeObserver } from "@/utils/useResizeObserver";

import type { EditorView } from "@tiptap/pm/view";

export function useGetPMNodeDomRect(view?: EditorView, pos: number = -1) {
  const [rect, setRect] = useState<DOMRect | null>(null);
  const node = view?.nodeDOM(pos);
  const element = node instanceof HTMLElement ? node : null;

  useResizeObserver(element, (entry) => {
    setRect(entry.contentRect);
  });

  return rect;
}
